import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

let refreshing = null;

api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const original = error.config;
    if (error.response?.status === 401 && original && !original._retry && !original.url.includes("/auth/")) {
      original._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        await refreshing;
        refreshing = null;
        return api(original);
      } catch (e) {
        refreshing = null;
        window.dispatchEvent(new Event("auth:expired"));
      }
    }
    return Promise.reject(error);
  }
);

const clean = (msg) => String(msg).replace(/^Value error, /, "");

export function formatApiError(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => clean(d?.msg ?? JSON.stringify(d))).join(" ");
  if (typeof detail?.msg === "string") return clean(detail.msg);
  return String(detail);
}

export function fieldErrorsFromApi(e) {
  const detail = e?.response?.data?.detail;
  if (!Array.isArray(detail)) return {};
  const out = {};
  detail.forEach((d) => {
    const msg = clean(d.msg || "");
    const m = msg.match(/^(\w+): (.*)$/);
    if (m) out[m[1]] = m[2];
    else if (d.loc?.length) out[d.loc[d.loc.length - 1]] = msg;
  });
  return out;
}
